// 设备管理繁体中文文案
const tr = {
  categoryManagement: "設備類目管理",
  addOrEditEquipmentCategory: "新增/編輯設備類目",
  addOrEditEquipmentInfo: "新增/編輯設備信息",
  addRootCategory: "新增主類目",
  addSubCategory: "新增子類目",
  batchSubCategories: "子類目",
  addBatchSubCategory: "新增子類目",
  removeSubCategory: "移除子類目",
  subCategoryItem: "子類目 {{index}}",
  editCategory: "編輯類目",
  disableCategory: "停用類目",
  enableCategory: "啟用類目",
  categoryCode: "類目編碼",
  categoryName: "類目名稱",
  categoryDesc: "類目描述",
  sortOrder: "排序",
  level: "層級",
  enabled: "已啟用",
  disabled: "已停用",
  selectCategoryPlaceholder: "請選擇設備類目",
  noCategoryData: "暫無設備類目",
  categoryCodeRequired: "請輸入類目編碼",
  categoryNameRequired: "請輸入類目名稱",
  confirmDisableCategory: "停用後將級聯停用所有子類目，確定繼續嗎？",
  confirmEnableCategory: "啟用後將級聯啟用所有父類目，確定繼續嗎？",
  categoryFetchFailed: "設備類目操作失敗",
  categoryOperationSucceeded: "設備類目操作成功",
  equipmentLedger: "設備列表",
  myBorrowed: "我的領用",
  maintainUpcoming: "保養到期",
  maintainUpcomingQuery: "保養到期查詢",
  equipmentList: "設備列表",
  addEquipment: "新增設備",
  editEquipment: "編輯設備",
  equipmentDetail: "設備詳情",
  equipmentCategory: "設備類目",
  equipmentNumber: "設備編號",
  equipmentName: "設備名稱",
  equipmentKeywordPlaceholder: "請輸入設備關鍵字",
  equipmentStatus: "設備狀態",
  brand: "品牌",
  model: "型號",
  serialNo: "序號",
  qrCode: "二維碼",
  disableEquipment: "停用",
  enableEquipment: "啟用",
  maintenanceRecord: "維護記錄",
  borrowEquipment: "領用",
  returnEquipment: "歸還",
  recordFlow: "流水記錄",
  recordDetail: "記錄詳情",
  operator: "操作人",
  borrower: "領用人",
  returnAt: "實際歸還時間",
  confirmDisableEquipment: "確定停用該設備嗎？",
  confirmEnableEquipment: "確定啟用該設備嗎？",
  equipmentStateUpdated: "設備狀態更新成功",
  equipmentStateUpdateFailed: "設備狀態更新失敗",
  qrCodeFetchFailed: "二維碼取得失敗",
  noQrCodeData: "暫無二維碼資料",
  addMaintenanceRecord: "新增維護記錄",
  recordType: "記錄類型",
  recordTypeRequired: "請選擇記錄類型",
  occurredAt: "發生時間",
  occurredAtRequired: "請選擇發生時間",
  expectedReturnAt: "預計歸還時間",
  scrapEquipment: "報廢",
  confirmScrapEquipment: "設備報廢後無法恢復，確定繼續嗎？",
  recordCost: "費用",
  recordCostCurrency: "幣種",
  odometer: "使用量",
  vendor: "服務商",
  recordComment: "備註",
  recordTypesFetchFailed: "記錄類型取得失敗",
  recordListFetchFailed: "記錄流水取得失敗",
  recordFetchFailed: "記錄詳情取得失敗",
  noRecordDetail: "暫無記錄詳情",
  addRecordSucceeded: "維護記錄新增成功",
  addRecordFailed: "維護記錄新增失敗",
  keeperOrg: "保管部門",
  ownedOrg: "購置/所屬部門",
  currentUser: "目前使用人",
  location: "位置",
  placeLocation: "放置地點",
  editPlaceLocation: "修改放置地點",
  placeLocationUpdateSucceeded: "放置地點更新成功",
  placeLocationUpdateFailed: "放置地點更新失敗",
  maintainDays: "保養週期（天）",
  maintainThreshold: "保養週期（使用量）",
  dueByDays: "天數維度",
  dueByThreshold: "使用量維度",
  due: "已到期",
  notDue: "未到期",
  remainDays: "剩餘天數",
  remainThreshold: "剩餘使用量",
  lastMaintainAt: "上次保養時間",
  lastMaintainOdometer: "上次使用量",
  currentOdometer: "目前使用量",
  purchaseInfo: "購置信息",
  purchaseAt: "購置時間",
  purchasePrice: "購置價格",
  purchaseCurrency: "購置幣種",
  supplier: "供應商",
  createdBy: "建立人",
  createdAt: "建立時間",
  updatedBy: "更新人",
  updatedAt: "更新時間",
  actions: "操作",
  equipmentNameRequired: "請輸入設備名稱",
  keeperOrgRequired: "請選擇保管部門",
  rootCategoryCannotAdd: "根類目不能新增設備，請選擇子類目",
  addEquipmentSucceeded: "設備新增成功",
  editEquipmentSucceeded: "設備編輯成功",
  equipmentSaveFailed: "設備儲存失敗",
  equipmentFetchFailed: "設備詳情取得失敗",
  equipmentListFetchFailed: "設備列表取得失敗",
  myBorrowedFetchFailed: "我的領用設備取得失敗",
  upcomingMaintainFetchFailed: "保養到期設備取得失敗",
  equipmentStatusFetchFailed: "設備狀態取得失敗",
  noEquipmentDetail: "暫無設備詳情",
};

export default tr;
